import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import { Box, Paper, Typography, Button } from "@mui/material";
import { ReactComponent as CancelIcon } from "../../static/svg/cancel.svg";
import CustomButton from "../Form/CustomButton";

export default function ActionModal({
  label1,
  label2,
  statement,
  modalstate,
  handleDelete,
  closeModal,
}) {
  // const closeModal = () => {
  //   setmodal(false);
  // };

  return (
    <div>
      {/* <Button  onClick={handleOpen}>Show backdrop</Button> */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={modalstate}
        // onClick={closeModal}
      >
        <Paper elevation={3} className="w-[300px] md:w-[600px] p-4 rounded-md">
          <Box>
            <Typography
              variant="body"
              lineHeight={{ xs: "200%", sm: "180%" }}
              fontSize={{ xs: "16px", sm: "30px" }}
              letterSpacing={"0.02em"}
              className="pl-6"
            >
              {statement}
            </Typography>
          </Box>
          <Box className="mx-auto mt-8 p-4 flex gap-4 md:gap-24 place-content-center">
            {/* <form onSubmit={handleDelete}> */}
            <CustomButton
              type="submit"
              color="secondary"
              className="text-sm w-[140px] h-[50px] md:w-[170px] md:h-[55px]"
              onClick={handleDelete}
              // fullWidth
            >
              {label1}
            </CustomButton>
            {/* </form> */}

            <CustomButton
              type="submit"
              // form="add-member-form"
              //   loading={true}
              // sx={{ width: "170px", height: "55px" }}
              color="secondary"
              className="text-sm w-[140px] h-[50px] md:w-[170px] md:h-[55px]"
              onClick={closeModal}
              // fullWidth
            >
              {label2}
            </CustomButton>
          </Box>
        </Paper>
      </Backdrop>
    </div>
  );
}
